const fonts = document.fonts || {
  addEventListener: () => {},
  removeEventListener: () => {},
};

export default fonts;
